import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import {
	browserPopupRedirectResolver,
	indexedDBLocalPersistence,
	initializeAuth,
} from 'firebase/auth';

import { environment } from '../environments/environment';

/**
 * Initialises the Firebase JS SDK, which is used for auth only.
 *
 * On iOS/Android two independent Firebase instances run side by side, both
 * in the same Firebase project but registered as different apps:
 *
 * - JS SDK (this one): runs in the WebView and always uses
 *   `environment.firebaseConfig`, so it identifies as the project's Web app
 *   (`appId` "…:web:…") on every platform.
 * - Native SDK: started by the iOS/Android shell from
 *   `GoogleService-Info.plist` / `google-services.json` ("…:ios:…" /
 *   "…:android:…"). Analytics is delivered through it via ./firebaseBridge,
 *   so events are attributed to the native app, not to this Web app.
 *
 * The JS SDK does not send analytics (no `firebase/analytics` in use).
 */
export const initFirebaseApp = () => {
	const app = initializeApp(environment.firebaseConfig);
	// TODO: maybe switch to native auth for better persistence

	if (Capacitor.isNativePlatform()) {
		// Explicit init needed for iOS: the default getAuth() adds the popup/redirect
		// resolver, whose iframe fails in the WKWebView and leaves auth unresolved.
		initializeAuth(app, {
			persistence: indexedDBLocalPersistence,
		});
	} else {
		//Needed for web apps since they use the Google popup login from the firebase instance
		initializeAuth(app, {
			persistence: indexedDBLocalPersistence,
			popupRedirectResolver: browserPopupRedirectResolver,
		});
	}
};
